export default __webpack_public_path__ + "static/media/automated-rules.ea6f8637.svg";